<template>
  <svg
    class="fill-current"
    :class="classObject"
    viewBox="0 0 106.3 138.1"
    @click="$emit('onClick')"
  >
    <path class="st0" d="M105.1,50.4L54.5,0.7c-0.9-0.9-2.3-0.9-3.2,0L1.2,50.4c-1.1,1-1.5,2.6-1.1,4l11.5,44.5c0.2,0.8,0.6,1.5,1.2,2
      l38.6,36.6c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.6-0.6l38.8-36.6c0.6-0.6,1-1.3,1.2-2.1l11.7-44.6
      C106.5,52.9,106.1,51.4,105.1,50.4 M52.5,3.3l0.1,65.1l-21.2-6.7c-0.7-0.4-1.8-1.4-1.5-3.1L52.5,3.3z M27.9,63.4
      c0.7-1,1.8-1.1,2.6-1.1l21.7,6.9L13.6,98.3L27.9,63.4z M74.9,62.5c0.6-0.2,2.2-0.4,3.3,0.9l14.4,34.9L54.1,69.2L74.9,62.5z
      M76.3,58.9c0.1,1.7-1.3,2.6-2,2.9l-20.8,6.6L53.4,3.3L76.3,58.9z M1.5,54c-0.2-1,0-2,0.7-2.7L52.1,1.9l-39.3,96L1.5,54z
      M53.6,136.5L53.6,136.5c-0.5,0.3-0.9,0.3-1.3,0L13.7,99.9c-0.1-0.1-0.2-0.2-0.3-0.3l39.7-30l39.5,30c-0.1,0.1-0.2,0.2-0.3,0.3
      L53.6,136.5z M104.9,53.9L93.4,97.9l-39.6-96l50.3,49.5C104.8,52.1,105.1,53,104.9,53.9"/>
  </svg>
</template>

<script>
export default {
  name: 'LogoSmall',
  props: {
    isLink: {
      type: Boolean,
      default: false
    },
    heightClass: {
      type: String,
      default: 'h-24'
    }
  },
  computed: {
    classObject () {
      return [
        this.heightClass,
        {
          'cursor-pointer': this.isLink
        }
      ]
    }
  },
  methods: {
  }
}
</script>
